import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Button } from 'app/dialogs/dialog-buttons.component';
import { SmartSortedDialogComponent
       } from 'app/dialogs/smart-sorted-dialog/smart-sorted-dialog.component';
import { ProductDesignerService } from 'app/product-designer.service';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';

@Injectable()
export class ProductUpgradeService
{
  private static readonly UPGRADE_PRODUCT_TARGETS: {[key: string]: any} = {
      'smart-sorted-puzzle-1000': SmartSortedDialogComponent,
  };

  constructor(
      private dialog: MatDialog,
      @Inject(ProductService) private productService: ProductService,
      @Inject(ProductDesignerService)
          private productDesignerService: ProductDesignerService,
      @Inject(DesignStepService) private designStepService,
      @Inject(EventTrackingService) private eventTrackingService:
          EventTrackingService)
  {}

  public async popUpgradeDialogIfPossible(
      templateGroupId: string,
      templateId: string): Promise<void>
  {
    if (this.productDesignerService.config.productUpgradeDialogPopped) {
      return;
    }
    if (Object.keys(ProductUpgradeService.UPGRADE_PRODUCT_TARGETS).includes(
        this.productService.getCurrentProduct().id)) {
      return;
    }
    const template = await this.designStepService.getTemplateById(
        templateGroupId, templateId);
    if (template.labels.filter(
        l => l.id === 'show_product_upgrade_layer' && l.value === 'yes').length
        === 0) {
      return;
    }
    const productIds = this.productService
      .getProducts()
      .filter(pc => pc.inStock)
      .map(pc => pc.id);
    const targetIds = Object
      .keys(ProductUpgradeService.UPGRADE_PRODUCT_TARGETS)
      .filter(i => productIds.includes(i));
    if (targetIds.length === 0) {
      return;
    }

    this.eventTrackingService.track({
      category: this.productService.getCurrentProduct().id,
      action: 'product_upgrade_popped',
    });

    const targetProductId = targetIds[0];
    const choice = await this.dialog
      .open(
          ProductUpgradeService.UPGRADE_PRODUCT_TARGETS[targetProductId],
          {data: {}, panelClass: 'dialog-pane'})
      .afterClosed()
      .toPromise();
    this.productDesignerService.config.productUpgradeDialogPopped = true;

    if (choice !== Button.Choice.OK) {
      return;
    }

    await this.productService.setCurrentProduct(targetProductId);
  }
}
